import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  NormalizedCacheObject,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { NEXT_PUBLIC_API_URL } from "@/config/env";
import { getToken } from "./actions";
import { errorLink } from "./apolloErrorLink";

const uploadLink = createUploadLink({
  uri: NEXT_PUBLIC_API_URL,
});

export const authLink = setContext(async (_, { headers }) => {
  const token = await getToken();
  return {
    headers: {
      ...headers,
      authorization: token?.accessToken ? `JWT ${token.accessToken}` : "",
    },
  };
});

let client: ApolloClient<NormalizedCacheObject> | null = null;

export function getClient() {
  if (!client) {
    client = new ApolloClient({
      cache: new InMemoryCache(),
      link: ApolloLink.from([errorLink, authLink, uploadLink]),
      defaultOptions: {
        mutate: {
          errorPolicy: "all",
        },
        query: {
          fetchPolicy: "no-cache",
          errorPolicy: "all",
        },
      },
    });
  }
  return client;
}

// For compatibility with existing code
export const query = getClient().query;
export const PreloadQuery = null; // This would need to be implemented differently if needed

// Helper function to clear Apollo cache
export const clearApolloCache = () => {
  const client = getClient();
  client.cache.reset();
};
